export interface VueFormulateSelect {
  options?: Array<{ label: string; value: string }>
  label?: string
  placeholder?: string
  showReset?: boolean
  showSelections?: boolean
  modelValue?: string[]
  valueProxy?: Ref<string[] | string>
}

export default function useVueFormulateSelect({
  options,
  placeholder,
  valueProxy,
}: VueFormulateSelect) {
  const showList = ref(false)

  const selectedOptions = computed(
    () =>
      options
        ?.filter((option) => valueProxy.value?.includes(option?.value))
        ?.map((option) => option.label)
        ?.join(', ') || placeholder,
  )
  const hasSelections = computed(
    () => !!(valueProxy.value?.length && valueProxy.value?.[0] !== ''),
  )
  function listToggle() {
    // TODO close on keyboard command - ESC?
    showList.value = !showList.value
  }

  return {
    showList,
    listToggle,
    valueProxy,
    selectedOptions,
    hasSelections,
  }
}
